import styled from '@emotion/styled';
import { createElement, FC } from 'react';

import { IssueComment, ProjectForCreationSetDetailFragment, User } from '../../../../graphql/generated/graphql';
import ProjectIssueComments from './ProjectIssueComments';
import ProjectIssueForm from './ProjectIssueForm';

interface Props {
  project: Pick<ProjectForCreationSetDetailFragment, 'id' | 'canIssueComment'> & {
    issue?:
      | (Pick<NonNullable<ProjectForCreationSetDetailFragment['issue']>, 'id'> & {
          comments: (Pick<IssueComment, 'id' | 'body' | 'updatedAt'> & {
            user: Pick<User, 'id' | 'name' | 'profileImageUrl'>;
          })[];
        })
      | null;
  };
  className?: string;
  onSubmitProjectIssue: (projectId: string, inputComment: string) => Promise<void>;
  onSubmitProjectIssueComment: (issueId: string, comment: string) => void;
  onUpdateProjectIssueComment: (commentId: string, comment: string) => void;
  onDeleteProjectIssueComment: (commentId: string) => void;
}

const ProjectIssue: FC<Props> = ({
  project,
  className,
  onSubmitProjectIssue,
  onSubmitProjectIssueComment,
  onUpdateProjectIssueComment,
  onDeleteProjectIssueComment,
}) => {
  return (
    <Root className={className} id={'issue.id'}>
      {project.issue ? (
        <ProjectIssueComments
          projectId={project.id}
          issue={project.issue}
          canIssueComment={project.canIssueComment}
          onUpdateProjectIssueComment={onUpdateProjectIssueComment}
          onDeleteProjectIssueComment={onDeleteProjectIssueComment}
        />
      ) : null}
      <ProjectIssueForm
        project={project}
        onSubmitProjectIssue={onSubmitProjectIssue}
        onSubmitProjectIssueComment={onSubmitProjectIssueComment}
      />
    </Root>
  );
};

const Root = styled('div')({});

export default ProjectIssue;
